// extracted by mini-css-extract-plugin
export var action = "support-module--action--4accd";
export var block = "support-module--block--6d37f";
export var blockName = "support-module--blockName--6a2ae";
export var blockText = "support-module--blockText--e7544";
export var blocksWrapper = "support-module--blocksWrapper--896ec";
export var section = "support-module--section--1a478";
export var text = "support-module--text--bd090";
export var title = "support-module--title--8aa8e";
export var wrapper = "support-module--wrapper--9860b";